// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import homelogo from "../assets/images/home/logo.png";
// import sparshImg from "../assets/images/home/sparsh.webp";
// import saharshImg from "../assets/images/home/saharsh.webp";
// import "../assets/css/header_style.css";
// import "../assets/css/Responsive/header_responsive.css";

// const projects = [
//   {
//     name: "Sparsh",
//     type: "3 BHK Flats & Shops",
//     location: "South Bopal Ahmedabad",
//     status: "Ready To Move In",
//     progress: 100,
//     image: sparshImg,
//   },
//   {
//     name: "Saharsh",
//     type: "2 & 3 BHK Flats & Shops",
//     location: "South Bopal",
//     status: "Under Construction",
//     progress: 60,
//     image: saharshImg,
//   },
// ];

// export default function Header() {
//   const [category, setCategory] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [menuOpen, setMenuOpen] = useState(false);

//   // const toggleMenu = () => setMenuOpen(!menuOpen);

//   // Close dropdown and nav menu when route changes
//   useEffect(() => {
//     setCategory(""); // Close project dropdown
//     setMenuOpen(false); // Close nav menu
//   }, [location.pathname]);

//   // Close menu on scroll
//   useEffect(() => {
//     const handleScroll = () => {
//       if (menuOpen) {
//         setMenuOpen(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [menuOpen]);

//   // Close menu + project dropdown on scroll
//   useEffect(() => {
//     const handleScroll = () => {
//       if (menuOpen) {
//         setMenuOpen(false);
//       }
//       if (category) {
//         // or if (isOpen)
//         setCategory(""); // close project dropdown
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [menuOpen, category]); // 👈 depend on both states

//   const handleProjectClick = (projectName) => {
//     if (projectName.toLowerCase() === "sparsh") {
//       navigate("/sparsh");
//     } else if (projectName.toLowerCase() === "saharsh") {
//       navigate("/saharsh");
//     }
//     setCategory(""); // Close dropdown after click
//   };

//   const isOpen = category === "Residential";

//   // const handleLinkClick = () => {
//   //   setMenuOpen(false);
//   // };

//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const toggleMenu = () => {
//     if (menuOpen) {
//       setCategory(""); // auto close Residential list
//     }
//     setMenuOpen(!menuOpen);
//   };

//   const handleLinkClick = () => {
//     setMenuOpen(false);
//     setCategory(""); // also close dropdown when navigating
//   };

//   return (
//     <div>
//       {/* <div className="header-container sticky-header"> */}
//       <div className={`header-container ${scrolled ? "scrolled" : ""}`}>
//         <header>
//           <nav>
//             <div className="nav-logo">
//               <Link to="/" onClick={handleLinkClick}>
//                 <img src={homelogo} alt="Nav-Logo" />
//               </Link>
//             </div>
//           </nav>

//           <button
//             className={`nav-toggle ${menuOpen ? "active" : ""}`}
//             onClick={toggleMenu}
//             aria-label="Toggle navigation menu"
//           >
//             <span></span>
//             <span></span>
//             <span></span>
//           </button>

//           <div className={`nav-menu ${menuOpen ? "active" : ""}`}>
//             <div className="container">
//               <ul>
//                 <li>
//                   <Link to="/" onClick={handleLinkClick}>
//                     Home
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/about" onClick={handleLinkClick}>
//                     About
//                   </Link>
//                 </li>

//                 <li>
//                   <span
//                     onClick={() =>
//                       setCategory(
//                         category === "Residential" ? "" : "Residential"
//                       )
//                     }
//                     style={{ cursor: "pointer", fontWeight: "500" }}
//                   >
//                     Residential &nbsp; <i class="fa-solid fa-caret-down"></i>
//                   </span>
//                 </li>

//                 <li>
//                   <Link to="/contact" onClick={handleLinkClick}>
//                     Contact Us
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </header>
//       </div>

//       {/* Project List Dropdown */}
//       {isOpen && (
//         <div className="project-list">
//           {projects.map((project) => (
//             <div
//               className="project-card"
//               key={project.name}
//               onClick={() => handleProjectClick(project.name)}
//               style={{ cursor: "pointer", position: "relative" }}
//             >
//               <button
//                 className="close-btn"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setCategory("");
//                 }}
//                 aria-label="Close project list"
//               >
//                 &times;
//               </button>

//               <img
//                 src={project.image}
//                 alt={project.name}
//                 className="project-image"
//               />

//               <div className="project-info">
//                 <h3>{project.name}</h3>
//                 <p>🏢 {project.type}</p>
//                 <p>📍 {project.location}</p>
//                 <div className="status">
//                   <div className="circular-progress">
//                     <svg className="progress-ring" width="60" height="60">
//                       <circle
//                         className="progress-ring__background"
//                         cx="30"
//                         cy="30"
//                         r="25"
//                       />
//                       <circle
//                         className="progress-ring__circle"
//                         cx="30"
//                         cy="30"
//                         r="25"
//                         style={{
//                           strokeDasharray: 2 * Math.PI * 25,
//                           strokeDashoffset:
//                             2 * Math.PI * 25 -
//                             (project.progress / 100) * (2 * Math.PI * 25),
//                         }}
//                       />
//                     </svg>
//                     <span className="progress-text">{project.progress}%</span>
//                   </div>
//                   <span>{project.status}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }












import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import homelogo from "../assets/images/home/logo.png";
import sparshImg from "../assets/images/home/sparsh.webp";
import saharshImg from "../assets/images/home/saharsh.webp";
import "../assets/css/header_style.css";
import "../assets/css/Responsive/header_responsive.css";

const projects = [
  {
    name: "Sparsh",
    type: "3 BHK Flats & Shops",
    location: "South Bopal Ahmedabad",
    status: "Ready To Move In",
    progress: 100,
    image: sparshImg,
  },
  {
    name: "Saharsh",
    type: "2 & 3 BHK Flats & Shops",
    location: "South Bopal",
    status: "Under Construction",
    progress: 60,
    image: saharshImg,
  },
];

export default function Header() {
  const [category, setCategory] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close dropdown and nav menu when route changes
  useEffect(() => {
    setCategory("");
    setMenuOpen(false);
  }, [location.pathname]);

  // Close menu + project dropdown on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (menuOpen) setMenuOpen(false);
      if (category) setCategory("");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [menuOpen, category]);

  const handleProjectClick = (projectName) => {
    if (projectName.toLowerCase() === "sparsh") {
      navigate("/sparsh");
    } else if (projectName.toLowerCase() === "saharsh") {
      navigate("/saharsh");
    }
    setCategory("");
  };

  const isOpen = category === "Residential";

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    if (menuOpen) setCategory("");
    setMenuOpen(!menuOpen);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    setCategory("");
  };

  return (
    <div>
      <div className={`header-container ${scrolled ? "scrolled" : ""}`}>
        <header>
          <nav>
            <div className="nav-logo">
              <NavLink to="/" onClick={handleLinkClick}>
                <img src={homelogo} alt="Nav-Logo" />
              </NavLink>
            </div>
          </nav>

          <button
            className={`nav-toggle ${menuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`nav-menu ${menuOpen ? "active" : ""}`}>
            <div className="container">
              <ul>
                <li>
                  <NavLink to="/" onClick={handleLinkClick}>
                    Home
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/about" onClick={handleLinkClick}>
                    About
                  </NavLink>
                </li>

                <li>
                  <span
                    onClick={() =>
                      setCategory(
                        category === "Residential" ? "" : "Residential"
                      )
                    }
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    Residential &nbsp;
                    <i className="fa-solid fa-caret-down"></i>
                  </span>
                </li>

                <li>
                  <NavLink to="/contact" onClick={handleLinkClick}>
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </header>
      </div>

      {/* Project List Dropdown */}
      {isOpen && (
        <div className="project-list">
          {projects.map((project) => (
            <div
              className="project-card"
              key={project.name}
              onClick={() => handleProjectClick(project.name)}
              style={{ cursor: "pointer", position: "relative" }}
            >
              <button
                className="close-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setCategory("");
                }}
                aria-label="Close project list"
              >
                &times;
              </button>

              <img
                src={project.image}
                alt={project.name}
                className="project-image"
              />

              <div className="project-info">
                <h3>{project.name}</h3>
                <p>🏢 {project.type}</p>
                <p>📍 {project.location}</p>

                <div className="status">
                  <div className="circular-progress">
                    <svg className="progress-ring" width="60" height="60">
                      <circle
                        className="progress-ring__background"
                        cx="30"
                        cy="30"
                        r="25"
                      />
                      <circle
                        className="progress-ring__circle"
                        cx="30"
                        cy="30"
                        r="25"
                        style={{
                          strokeDasharray: 2 * Math.PI * 25,
                          strokeDashoffset:
                            2 * Math.PI * 25 -
                            (project.progress / 100) *
                            (2 * Math.PI * 25),
                        }}
                      />
                    </svg>
                    <span className="progress-text">
                      {project.progress}%
                    </span>
                  </div>
                  <span>{project.status}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
